import * as React from 'react'
import { IconsModel } from '../types/iconsModel'

const SvgPossibiliteParking = (
	{
		color,
		width = 45,
		height = 35
	}: IconsModel
) => (
	<svg
		id="possibiliteParking_svg__FULL_VECTO_SEUL"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 425.2 425.2"
		width={width}
		height={height}
	>
		<defs>
			<style>{`.prestation_cls_fill{fill:${color}`}</style>
		</defs>
		<path
			className="prestation_cls_fill"
			d="M344.98 344.98H80.22V80.22h264.76v264.76ZM90.2 334.99h244.79V90.2H90.2v244.79Z"
		/>
		<path
			className="prestation_cls_fill"
			d="m211.11 218.56.92-.2c7.07-1.54 22.22-8.4 22.22-39.32 0-22.02-7.27-36.05-31.33-36.05v114.48l12.8 24.78v1.54h-70.86v-1.54l10.75-24.78v-94.72l-10.75-24.78v-1.54h73.52c43.93 0 65.43 17.41 65.43 42.8s-22.43 45.88-67.99 45.88h-4.71v-6.55Z"
		/>
	</svg>
)
export default SvgPossibiliteParking
